import * as React from "react";
import { Icon } from "../../Icon/icon";
import { PaginationNextProps } from "./WizardPagination.types";

export class Next extends React.Component<PaginationNextProps> {
  private navigateNext = (
    currentStepIndex: number,
    e: React.MouseEvent<HTMLAnchorElement>
  ) => {
    this.props.changeStepCallback(
      this.props.paginationSteps[currentStepIndex + 1].stepId,
      e
    );
  };

  public render() {
    let anchorClassName = "pagination__link pagination__link--next";
    let buttonClassName = "button button--blue-arrow";
    let currentStepIndex = this.props.currentStepIndex;
    let isDisabled = currentStepIndex === this.props.stepLength - 1;
    if (isDisabled) anchorClassName += " pagination__link--disabled";
    let JSX = null;
    if (this.props.showButtons) {
      if (!isDisabled) {
        JSX = (
          <a
            onClick={(e) => this.navigateNext(currentStepIndex, e)}
            href="#"
            className={buttonClassName}
          >
            {this.props.nextLabel}
          </a>
        );
      }
    } else {
      if (!isDisabled) {
        JSX = (
          <a
            onClick={(e) => this.navigateNext(currentStepIndex, e)}
            href="#"
            className={anchorClassName}
          >
            <span className="pagination__verbose">{this.props.nextLabel}</span>
            <Icon iconType="fontawesome/chevron-left" />
          </a>
        );
      } else {
        JSX = (
          <span aria-disabled="true" className={anchorClassName}>
            <span className="pagination__verbose">{this.props.nextLabel}</span>
            <Icon iconType="fontawesome/chevron-left" />
          </span>
        );
      }
    }

    return JSX;
  }
}
